define(['jquery', 'common', 'booking_rules', 'jqueryvalidate', 'jqueryvalidate_unobtrusive'],
	function ($, Common, BookingRules) {
		var ERVValidationExtensions = function () {
			var self = this;
			self.common = new Common();
			self.bookingRules = new BookingRules();
		}

		ERVValidationExtensions.prototype.init = function () {
			var self = this;

			$.validator.setDefaults({
				ignore: '.ignore-validation',
				validClass: 'input-validation-valid'
			});

			$.validator.methods.number = function (value, element) {
				return this.optional(element) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:(\.|,)\d+)?$/.test(value);
			}

			$.validator.addMethod('bookingbusinesstraveldays', function (value, element) {
				return self.bookingRules.businessTravelDaysRule($(element).closest('form'));
			});

			$.validator.unobtrusive.adapters.add('bookingbusinesstraveldays', [], function (options) {
				options.rules['bookingbusinesstraveldays'] = {};
				options.messages['bookingbusinesstraveldays'] = options.message;
			});

			$.validator.addMethod('timeformat', function (value) {
				return /^(\d|0\d|1?\d|2[0-3]):[0-5]?\d$/.test(value);
			});

			$.validator.unobtrusive.adapters.add('timeformat', [], function (options) {
				options.rules['timeformat'] = {};
				options.messages['timeformat'] = options.message;
			});

			$.validator.addMethod('requiredif', function (value, element, parameters) {
				var targetvalue = parameters['targetvalue'];
				targetvalue = (targetvalue == null ? '' : targetvalue).toString();

				var $control = $('[id="' + parameters['dependentproperty'] + '"]');

				if ($control.length === 0) {
					$control = $('#Input_' + parameters['dependentproperty']);
				}

				if ($control.length === 0) {
					$control = $('#InputRequire_' + parameters['dependentproperty']);
				}

				if ($control.length === 0) {
					$control = $('[id$="_' + parameters['dependentproperty'] + '"]');
				}

				if ($control.length === 0) {
					return true;
				}

				var controltype = $control.attr('type');

				var actualvalue =
					controltype === 'checkbox' ?
						$control.prop('checked').toString() :
						$control.val();

				if (typeof (actualvalue) != 'undefined' && targetvalue.toLowerCase() === actualvalue.toLowerCase()) {
					return $.validator.methods.required.call(this, value, element, parameters);
				}

				var $controlWithNameMatchingAndChecked = $('input[name$=".' + parameters['dependentproperty'].replace + '"]:checked');

				if ($controlWithNameMatchingAndChecked.length) {
					if (targetvalue.toLowerCase() == $controlWithNameMatchingAndChecked.val().toLowerCase()) {
						return $.validator.methods.required.call(this, value, element, parameters);
					}
				}

				return true;
			});

			$.validator.unobtrusive.adapters.add('requiredif', ['dependentproperty', 'targetvalue'], function (options) {
				options.rules['requiredif'] = {
					dependentproperty: options.params['dependentproperty'],
					targetvalue: options.params['targetvalue']
				};
				options.messages['requiredif'] = options.message;
			});

			$.validator.unobtrusive.adapters.add('dategreaterthan', ['otherproperty'], function (options) {
				options.rules['dategreaterthan'] = { otherproperty: options.params.otherproperty };
				options.messages['dategreaterthan'] = options.message;
			});

			$.validator.addMethod("dategreaterthan", function (value, element, param) {
				var $otherProp = $('#Input_' + param.otherproperty);
				$otherProp.removeClass('input-validation-error');
				$otherProp.parent().find('.field-validation-error').empty();

				if (value === '') {
					$(element).removeClass('input-validation-error');
					$(element).parent().find('.field-validation-error').empty();
					return true;
				}

				if ($otherProp.val() !== '') {
					var otherDate = $otherProp.val();
					var date = value;

					if ($('html').data('domain') === 'dk') {
						otherDate = self.common.formatting.reverseShortDate(otherDate);
						date = self.common.formatting.reverseShortDate(date);
					}

					return new Date(date) >= new Date(otherDate);
				}
				return true;
			});

			$.validator.unobtrusive.adapters.add('datelessthan', ['otherproperty'], function (options) {
				options.rules['datelessthan'] = { otherproperty: options.params.otherproperty };
				options.messages['datelessthan'] = options.message;
			});

			$.validator.addMethod("datelessthan", function (value, element, param) {
				var $otherProp = $('#Input_' + param.otherproperty);
				$otherProp.removeClass('input-validation-error');
				$otherProp.parent().find('.field-validation-error').empty();
				if (value === '') {
					$(element).removeClass('input-validation-error');
					$(element).parent().find('.field-validation-error').empty();
					return true;
				}

				if ($otherProp.val() !== '') {
					var otherDate = $otherProp.val();
					var date = value;

					if ($('html').data('domain') === 'dk') {
						date = self.common.formatting.reverseShortDate(date);
						otherDate = self.common.formatting.reverseShortDate(otherDate);
					}

					return new Date(date) <= new Date(otherDate);
				}
				return true;
			});

			$.validator.addMethod("mandatory", function (value, element) {
				var $container = $(element).parent(),
					$visibleLabel = $container.find('label:not(.hidden)');


				if (typeof (value) === 'undefined') {
					$visibleLabel.addClass('input-validation-error');
				} else {
					$visibleLabel.removeClass('input-validation-error');
					return true;
				}
				return false;
			});

			$.validator.unobtrusive.adapters.add('mandatory', function (options) {
				options.rules['mandatory'] = true;

				if (options.message) {
					options.messages['mandatory'] = options.message;
				}
			});

			$.validator.addMethod('regextest', function (value, _, parameter) {
				var regEx = new RegExp(parameter);
                return regEx.test(value);
			});

			$.validator.unobtrusive.adapters.add('numbergreaterthan', ['validatefrom'], function (options) {
				options.rules['numbergreaterthan'] = {
					validatefrom: options.params['validatefrom']
                };
				options.messages['numbergreaterthan'] = options.message;
            });

			$.validator.addMethod("numbergreaterthan", function (value, _, param) {
                var validateFrom = parseFloat(param['validatefrom']);
                var floatValue = parseFloat(value.replace(',', '.'));
				var roundedValue = Math.round((floatValue + Number.EPSILON) * 100) / 100;
				return roundedValue > validateFrom;
			});

            $.validator.unobtrusive.adapters.add('dynamicregex', ['patternfrom'], function (options) {
				options.rules['dynamicregex'] = {
                    patternfrom: options.params['patternfrom']
                };
				options.messages['dynamicregex'] = options.message;
            });

			$.validator.addMethod("dynamicregex", function (value, element, param) {
				var longname = $(element).attr('id');
				var name = longname.split('_').slice(-1);
				var patternName = longname.replace(name, param.patternfrom);
				var $otherProp = $('#' + patternName);
				var regEx = new RegExp($otherProp.val());
                return regEx.test(value);
            });

			$('form').removeData('validator');
			$('form').removeData('unobtrusiveValidation');

			$.validator.unobtrusive.parse(document);
			setTimeout(ensureAutocompleteHasListItem, 0);

			//happens for example in healthdeclaration for date fields
			//needs each
			$('.is-date input').not(".ignore-validation").each(function () {
				$(this).rules('remove', 'date');
			});

			//happens for example on allforonecancellation
			//needs each
			$('input[data-val-number][type="number"]').each(function () {
				$(this).rules('remove', 'number');
			});

			//seems to be jquery validation which automatically adds this data attribute when @Html helper is used to create a textbox
			//Not sure but it also seems like it corrensponds with the prop being a nullable type in the viewmodel
		}

		function ensureAutocompleteHasListItem() {
			$('.ui-autocomplete').each(function() {
				if ($(this).children('li').length === 0) {
					$(this).append('<li style="display:none;">Select</li>');
				}
			});
		}
		
		return ERVValidationExtensions;
	});